module.exports = __webpack_public_path__ + "img/asset13.a41d11c1.svg";